<p-table stripedRows #dtSessionNumber
    [value]="items"
    dataKey="id"
    editMode="row"
    [(selection)]="selected"
    scrollHeight="flex"
    [scrollable]="true"
    [multiSortMeta]="[
        { field: 'CName', order: 1},
        { field: 'SessionStart', order: 2},
        { field: 'SessionEnd', order: 3}
    ]"
    sortMode="multiple"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td colspan="7" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <!-- <th style="width: 3em; text-align: center" >
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->

            <!-- Contract -->
            <th pSortableColumn="CName">
                Contract/Charge Number
                <p-sortIcon title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                    field="CName"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="CName" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="contracts"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Session Start Date -->
            <th pSortableColumn="SessionStart">
                Invoice Start
                <p-sortIcon title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                    field="SessionStart"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="SessionStart" display="menu" class="ml-auto" />
                <!-- <p-columnFilter field="SessionStart" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-calendar
                            #calInvoiceSessionStartDateFilter
                            [yearNavigator]="true"
                            yearRange="2000:2021"
                            inputId="calInvoiceSessionStartDateFilter"
                            inputStyleClass="clearable-date-filter p-inputtext"
                            placeholder="Filter"
                            [(ngModel)]="startDateFilter"
                            [ngModelOptions]="{ standalone: true }"
                            appendTo="body"
                            selectionMode="range"
                            [readonlyInput]="false"
                            dateFormat="mm/dd/yy"
                            (onSelect)="filter($event.value)"
                        >
                        </p-calendar>
                    </ng-template>
                </p-columnFilter> -->
            </th>
            <!-- Session End Date -->
            <th pSortableColumn="SessionEnd">
                Invoice End
                <p-sortIcon title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                    field="SessionEnd"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="SessionEnd" display="menu" class="ml-auto" />
                <!-- <p-columnFilter field="SessionEnd" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-calendar
                            #calInvoiceSessionEndDateFilter
                            [yearNavigator]="true"
                            yearRange="2000:2021"
                            inputId="calInvoiceSessionEndDateFilter"
                            inputStyleClass="clearable-date-filter p-inputtext"
                            placeholder="Filter"
                            [(ngModel)]="endDateFilter"
                            [ngModelOptions]="{ standalone: true }"
                            appendTo="body"
                            selectionMode="range"
                            [readonlyInput]="false"
                            dateFormat="mm/dd/yy"
                            (onSelect)="filter($event.value)"
                        >
                        </p-calendar>
                    </ng-template>
                </p-columnFilter> -->
            </th>
            <!-- Invoice Number -->
            <th pSortableColumn="InvoiceNbr">
                Invoice
                <!-- <p-sortIcon title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                    field="InvoiceNbr"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon> -->
                <p-columnFilter type="text" matchMode="contains" field="InvoiceNbr" display="menu" class="ml-auto" />
            </th>
            <!-- Voucher -->
            <th pSortableColumn="VoucherNbr">
                Voucher
                <p-sortIcon title="Numbers on columns are the display of the current sort order. CTRL click on another column to multi sort."
                    field="VoucherNbr"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="VoucherNbr" display="menu" class="ml-auto" />
            </th>
            <th
                *ngIf="this.process?.ProcessID != 121"
                style="text-align: center" class="delete-cell"
            >

            </th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <td class="edit-cell">
                <!-- for a new row -->
                <button
                    title="Add"
                    *ngIf="item?.id === 'add' && !edit"
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-plus"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditInit(item)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    title="Save"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    title="Cancel"
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <!-- <td
                    style="width: 3em; text-align: center"
                    class="p-datatable-cell"
                >
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td> -->
            <!-- Edit -->

            <!-- Contract -->
            <td>
                {{ item.CName }}
            </td>
            <!-- Session Start Date -->
            <td>
                <!-- <p-cellEditor *ngIf="this.process?.ProcessID != 121">
                    <ng-template pTemplate="input">
                        <p-calendar
                            [(ngModel)]="item.SessionStart"
                            monthNavigator="true"
                            yearNavigator="true"
                            yearRange="2010:2030"
                            appendTo="body"
                        >
                        </p-calendar>
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            moment(item?.SessionStart).isValid()
                                ? moment(item?.SessionStart).format(
                                      'MM/DD/YYYY'
                                  )
                                : ''
                        }}
                    </ng-template>
                </p-cellEditor> -->
                <span>
                    {{
                        moment(item?.SessionStart).isValid()
                            ? moment(item?.SessionStart).format('MM/DD/YYYY')
                            : ''
                    }}
                </span>
            </td>
            <!-- Session End Date -->
            <td>
                <p-cellEditor *ngIf="this.process?.ProcessID != 121">
                    <ng-template pTemplate="input">
                        <p-select
                            [options]="sessionEndSelectItem"
                            [filter]="false"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            [(ngModel)]="item.SessionEnd"
                        >
                        </p-select>
                        <!-- <p-calendar
                            [(ngModel)]="item.SessionEnd"
                            monthNavigator="true"
                            yearNavigator="true"
                            yearRange="2010:2030"
                            appendTo="body"
                            [maxDate]="LastInvoiceEnd"
                        >
                        </p-calendar> -->
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            moment(item?.SessionEnd).isValid()
                                ? moment(item?.SessionEnd).format('MM/DD/YYYY')
                                : ''
                        }}
                    </ng-template>
                </p-cellEditor>
                <span *ngIf="this.process?.ProcessID == 121">
                    {{
                        moment(item?.SessionEnd).isValid()
                            ? moment(item?.SessionEnd).format('MM/DD/YYYY')
                            : ''
                    }}
                </span>
            </td>
            <!-- Invoice Number -->
            <td>
                <p-cellEditor *ngIf="this.process?.ProcessID == 121">
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input
                            title="Invoice Number"
                            pInputText
                            [(ngModel)]="item.InvoiceNbr"
                            [ngModelOptions]="{ standalone: true }"
                        />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.InvoiceNbr }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.InvoiceNbr }}
                    </ng-template>
                </p-cellEditor>
                <span *ngIf="this.process?.ProcessID != 121">
                    {{ item?.InvoiceNbr }}
                </span>
            </td>
            <!-- Voucher -->
            <td>
                <p-cellEditor *ngIf="this.process?.ProcessID == 121">
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input
                            title="Voucher Number"
                            pInputText
                            [(ngModel)]="item.VoucherNbr"
                            [ngModelOptions]="{ standalone: true }"
                        />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item?.VoucherNbr }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item?.VoucherNbr }}
                    </ng-template>
                </p-cellEditor>
                <span *ngIf="this.process?.ProcessID != 121">
                    {{ item?.VoucherNbr }}
                </span>
            </td>
            <td
                *ngIf="this.process?.ProcessID != 121"
                style="text-align: center"
                class="delete-cell"
                title="Delete available for last invoice"
            >
                <button
                    *ngIf="
                        item?.DeleteAllowed == true
                    "
                    pButton
                    icon="pi pi-trash"
                    class="p-button-text p-button-danger"
                    (click)="deleteClicked(rowData)"
                ></button>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Are you sure?" [(visible)]="displayDeleteDialog" [modal]="true" [style]="{width: '25em'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">

    <label>{{invoiceDeleteMessage}}</label>

    <ng-template #footer>
        <button
            pButton
            label="Confirm"
            class="p-button-text"
            (click)="deleteInvoiceSession()"
        ></button>
        <button
            pButton
            label="Cancel"
            class="p-button-text"
            (click)="displayDeleteDialog = false"
        ></button>
    </ng-template>
</p-dialog>
